module.exports = __webpack_public_path__ + "img/a5b3397dc886cee5a91dca5921e2679b.c2a2c949.jpg";